module.exports = __webpack_public_path__ + "assets/img/4.231ea12f.png";